import {integrityProfCourse} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useIntegrityProfCourse(selection: any) {
  return useLoad(
    integrityProfCourse,
    ['iD_Course', 'iD_ProfileSpac'],
    selection,
  );
}

export default useIntegrityProfCourse;
